<template>
  <b-container v-if="tour360" class="py-5">
    <div class="py-4" ref="tour360">
      <h3 class="pilots-title text-left my-3">Vista 360°</h3>
      <iframe
        v-if="showTour"
        :src="tour360"
        tabindex="-1"
        width="100%"
        height="600px"
        loading="lazy"
        style="border: none; border-radius: 10px"
      />
      <div
        v-else
        class="w-100 text-center py-5"
        :style="{
          backgroundImage: `url(${require('@/assets/images/project/blur360.png')})`,
          backgroundSize: 'cover',
          height: '600px',
          borderRadius: '10px',
        }"
      >
        <b-button
          variant="light-green"
          size="lg"
          @click="showTour = true"
          style="
            margin-top: 200px;
            margin-left: auto;
            margin-right: auto;
            font-size: 24px;
            padding: 17px;
          "
          >Ver Tour 360°</b-button
        >
      </div>
    </div>
  </b-container>
</template>
<script>
export default {
  props: {
    tour360: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showTour: false,
    };
  },
};
</script>
<style lang="scss" scoped>
.pilots-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 31px;
  line-height: 40px;
  /* identical to box height, or 129% */

  letter-spacing: 0.1px;
  text-transform: uppercase;
}
</style>
